import styled from "styled-components";
import { spacing, color } from "@conserveit/blocks";

export const Content = styled.div`
  display: flex;
  border-top: 1px solid ${color.theme.divider.solid};
  flex-basis: 100%;
  flex-grow: 1;
  overflow: hidden;
`;

export const Left = styled.div`
  flex-basis: 50%;
  height: 100%;
  border-right: 1px solid ${color.theme.divider.solid};
`;

export const Right = styled(Left)`
  box-shadow: none;
  overflow-y: scroll;
  background: ${color.pureWhite};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${spacing.default};
  border-top: 1px solid ${color.theme.divider.solid};
  background: ${color.pureWhite};
`;

export const IssuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SearchContainer = styled.div``;

export const IssueList = styled.div<{ noResults: boolean }>`
  flex: 1 0;
  position: relative;
  overflow-y: ${(props) => (props.noResults ? "hidden" : "auto")};
`;
